export default __webpack_public_path__ + "static/media/logo-ig-white.ddb1b23c.svg";